import i18n from '@/lang'

import { Message } from 'element-ui'

export const success = () => {
    Message.success(i18n.tc('form.success'))
}
export const fail = () => {
    Message.error(i18n.tc('form.fail'))
}

export const failMsg = (msg = '') => {
    if (typeof msg !== 'string') {
        let msgL = ''
        switch (i18n.locale) {
            case 'chinese':
                msgL = '未知的错误'
                break
            case 'english':
                msgL = 'An unknown error'
                break
            default:
                msgL = 'An unknown error'
                break
        }
        Message.error(msgL)
    } else {
        let msgList = msg.split('\n')
        let msgL = ''
        if(msgList.length > 1){
            switch (i18n.locale) {
                case 'chinese':
                    msgL = msgList[0]
                    break
                case 'english':
                    msgL = msgList[1]
                    break
                default:
                    msgL = msgList[1]
                    break
            }
            Message.error(msgL)
        }else{
            Message.error(msg)
        }
    }
}

export const getAllParams = geturl => {
    const url = geturl //获取url中"?"符后的字串
    let theRequest = new Object()
    if (url.indexOf('?') != -1) {
        let str = url.substr(1)
        strs = str.split('&')
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
        }
    }
    return theRequest
}
export const isMobile = () => {
    if (
        window.navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
        )
    ) {
        return true // 移动端
    } else {
        return false // PC端
    }
}

export const inserSeoElement = (titleText, key, dec) => {
    const head = document.head || document.getElementsByTagName('head')[0]
    const meta = document.getElementById('tkdKey') || document.createElement('meta')
    const meta2 = document.getElementById('tkdDec') || document.createElement('meta')
    const title = document.getElementById('tdkTitle') || document.createElement('title')
    title.innerText = titleText
    title.setAttribute('id', 'tdkTitle')

    meta.setAttribute('name', 'keywords')
    meta.setAttribute('content', key)
    meta.setAttribute('id', 'tkdKey')

    meta2.setAttribute('name', 'description')
    meta2.setAttribute('id', 'tkdDec')
    meta2.setAttribute('content', dec)


    if (!document.getElementById('tkdDec')) {
        head.insertBefore(meta2, head.children[0])
    }

    if (!document.getElementById('tkdKey')) {
        head.insertBefore(meta, head.children[0])
    }
    if (!document.getElementById('tdkTitle')) {
        head.insertBefore(title, head.children[0])
    }
}


export const inserRobotsSeoElement = () => {
    const head = document.head || document.getElementsByTagName('head')[0]
    const meta = document.getElementById('robotsId') || document.createElement('meta')
	meta.setAttribute('name', 'robots')
	meta.setAttribute('id', 'robotsId')
	meta.setAttribute('content', 'noindex, nofollow')
    if (!document.getElementById('robotsId')) {
        head.insertBefore(meta, head.children[0])
    }
}

export const debounce = (fn, delay = 300) => {
  let timer = null;
  return function(...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
//获取地址栏URL参数并转换为JSON对象
export const getUrlParams = ()=> {
  const searchParams = new URLSearchParams(window.location.search);
  const params = {};
  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }
  return params;
}
export const getUUID = () => {
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
  return uuid
}

//判断流量来源 1. 谷歌搜索广告 2. 谷歌自然搜索 3.其他自然搜索 4.网址访问
export const  getTrafficSource = ()=> {
  
    // 直接网址访问
    if (!document.referrer) return 4
    try {
        const urlParams = new URLSearchParams(window.location.search);
        // 检查是否是谷歌搜索广告 (带有gclid参数)
        if (urlParams.has('gclid')&&document.referrer.includes('google.com')) {
            return 1;
        }else if(document.referrer.includes('google.com')){
            return 2;
        }else if(!document.referrer.includes(href)){
            return 3;
        }else{
        // 默认情况为直接访问
        return 4;
        } 
    } catch (e) {
        return 4;
    }
}